import { makeAutoObservable, runInAction } from "mobx"
import { aiBridge } from "../services/ai-adapter/bridge"
import type {
  AiChatResult,
  AiContext,
  AiConversation,
  AiConversationId,
  AiTask,
} from "../services/ai-adapter/protocol"

export class AiConnectionStore {
  historyLoading = false
  chatLoading = false
  error: string | null = null
  private bridge = aiBridge

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  get loading() {
    return this.historyLoading || this.chatLoading
  }

  history = async (conversationId: AiConversationId): Promise<AiConversation> => {
    runInAction(() => {
      this.historyLoading = true
      this.error = null
    })

    try {
      return await this.bridge.history(conversationId)
    } catch (e: unknown) {
      runInAction(() => {
        this.error = e instanceof Error ? e.message : String(e)
      })
      throw e
    } finally {
      runInAction(() => {
        this.historyLoading = false
      })
    }
  }

  /**
   * Send a chat turn for an entity-scoped conversation (`claim:…`, `message:…`, …).
   */
  ask = async (
    conversationId: AiConversationId,
    task: AiTask,
    userMessage: string,
    context: AiContext,
    utility: string,
  ): Promise<AiChatResult> => {
    runInAction(() => {
      this.chatLoading = true
      this.error = null
    })

    try {
      return await this.bridge.chat(conversationId, task, userMessage, context, utility)
    } catch (e: unknown) {
      runInAction(() => {
        this.error = e instanceof Error ? e.message : String(e)
      })
      throw e
    } finally {
      runInAction(() => {
        this.chatLoading = false
      })
    }
  }
}
